import { useState, useEffect } from 'react'
import axios from 'axios'

import { Form, Button, Row, Col, Modal, Spinner } from 'react-bootstrap';

const API_PATH = "https://somosglotones.com/srv/api/euk/sendFotoLanding";
const SITE_KEY = "6LdAcZosAAAAANkpm2eYjqcvlZbl-ZiOg7eLmfIL";

const BrutalistForm = () => {
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [email, setEmail] = useState("")
  const [comments, setComments] = useState("")
  const [rrss, setRrss] = useState("")

  const [showMessage, setShowMessage] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [textBtn, setTextBtn] = useState('¡REGISTRAR MI MARCA!')

  useEffect(() => {

    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    }

    // load the script by passing the URL
    loadScriptByURL("recaptcha-key", `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`, function () {
      console.log("Script loaded!");
    });
  }, []);

  const handleCloseMessage = () => setShowMessage(false);

  const handleOnClick = (e) => {
    e.preventDefault();
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(SITE_KEY, { action: 'submit' }).then(token => {
        handleOnSubmit(token);
      });
    });
  }

  const handleOnSubmit = (token) => {
    var form = document.getElementById('contactForm');
    var data = new FormData(form);
    data.append('recaptcha_response', token);

    setTextBtn("Enviando...")
    setIsActive(true)

    axios.post(API_PATH, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(function (response) {

      if (response.data === "FAIL" || response.data === "ERROR") {
        setTextBtn("ENVIAR")
        setIsActive(false)

        setTitle("Error")
        setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
        setShowMessage(true)
      } else {
        setTextBtn("¡REGISTRAR MI MARCA!")
        setIsActive(false)

        setTitle("Mensaje enviado")
        setMessage("Tu registro ha sido completado. ¡Muchas gracias! Nos comunicaremos contigo en caso de ser uno de nuestros ganadores.");
        setShowMessage(true)

        setName("");
        setPhone("");
        setEmail("");
        setComments("");
        setRrss("");
      }

    }).catch(function (err) {
      setTextBtn("ENVIAR")
      setIsActive(false)

      setTitle("Error")
      setMessage("Ocurrió un error al intentar enviar tu mensaje, por favor intenta mas tarde.");
      setShowMessage(true)
    });
  }

  return (
    <>

      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header style={{ background: "#fff" }} closeButton>
          <Modal.Title style={{ color: "#000" }}>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ color: "#000", background: "#fff" }}>{message}</Modal.Body>
        <Modal.Footer style={{ color: "#000", background: "#fff" }}>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="form-container-brutalist p-4 pt-0">
        <Form id="contactForm" onSubmit={handleOnClick}>
          <Row>
            <Col md={6} className="mb-4">
              <Form.Group>
                <Form.Label className="label-brutalist">Tu Nombre</Form.Label>
                <Form.Control
                  required
                  type="text"
                  value={name} name="name"
                  placeholder="EJ. SOFIA GARCÍA"
                  className="input-brutalist"
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={6} className="mb-4">
              <Form.Group>
                <Form.Label className="label-brutalist">Nombre del Restaurante</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="comments" value={comments}
                  size='sm'
                  placeholder="EJ. RESTAURANTE BISTRO"
                  className="input-brutalist"
                  onChange={(e) => setComments(e.target.value)}
                />
              </Form.Group>
            </Col>

            {/* Correo */}
            <Col md={6} className="mb-4">
              <Form.Group>
                <Form.Label className="label-brutalist">Email</Form.Label>
                <Form.Control
                  required
                  type="email"
                  value={email} name="email"
                  size='sm'
                  placeholder="HOLA@RESTAURANTE.COM"
                  className="input-brutalist"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
            </Col>

            {/* Teléfono */}
            <Col md={6} className="mb-4">
              <Form.Group>
                <Form.Label className="label-brutalist">Teléfono</Form.Label>
                <Form.Control
                  required
                  value={phone} name="phone"
                  type="tel"
                  size='sm'
                  placeholder="55 1234 5678"
                  className="input-brutalist"
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Form.Group>
            </Col>

            {/* Instagram o Facebook */}
            <Col md={12} xs={12} className="mb-4">
              <Form.Group>
                <Form.Label className="label-brutalist">Instagram o Facebook</Form.Label>
                <Form.Control
                  required
                  value={rrss} name="rrss"
                  type="text"
                  size='sm'
                  placeholder="@eureka_marketing"
                  className="input-brutalist"
                  onChange={(e) => setRrss(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <div className="text-center mt-3">
            <Button type="submit" className="btn-submit-brutalist w-100">
              <Spinner
                className={isActive ? '' : 'hide'}
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              {textBtn}
            </Button>
            <p className="mt-5 small text-uppercase opacity-50" style={{ letterSpacing: '2px', fontSize: '11px' }}>
              * Al registrarte aceptas que nos pondremos en contacto para la dinámica.
            </p>
          </div>
        </Form>
      </div>
    </>
  );
};

export default BrutalistForm;